import {translate} from "./language";
import $ from "expose-loader?exposes=$,jQuery!jquery";
import {passiveListeners} from "./passive";
import {imageLazyLoad} from "./lazyload";
import {Frontend} from "./frontend-new";
import {mobileNew} from "./mobile-new";
import {runAfterAjax} from "./common-new";
import * as globals from "./globals";
//import "jquery-ui/ui/widgets/datepicker";
import "bootstrap";
import {cModal} from "./c-modal-new";
import {fastMessageStart} from "./fastmessages-new";
import("./../plugins/cookie-approve/cookie-approve-new");
passiveListeners();

/*jQuery.datepicker.setDefaults({
    //showAnim:'fadeIn',
    currentText: 'Dnes',
    closeText: 'OK',
    prevText: 'Předchozí',
    nextText: 'Další',
    dateFormat: 'd.m.yy',
    firstDay: 1,
    dayNamesMin: ["Ne", "Po", "Út", "St", "Čt", "Pá", "So"],
    dayNamesShort: ["Neď", "Pon", "Úte", "Stř", "Čtv", "Pát", "Sob"],
    dayNames: ["Neděle", "Pondělí", "Úterý", "Středa", "Čtvrtek", "Pátek", "Sobota"],
    monthNamesShort: ["Led", "Úno", "Bře", "Dub", "Kvě", "Črn", "Črc", "Srp", "Zář", "Říj", "Lis", "Pro"],
    monthNames: ["Leden", "Únor", "Březen", "Duben", "Květen", "Červen", "Červenec", "Srpen", "Září", "Říjen", "Listopad", "Prosinec"]
});

if (jQuery.timepicker) jQuery.timepicker.setDefaults({
    timeOnlyTitle: translate('Zvol čas'),
    timeText: translate('Čas'),
    hourText: translate('Hodiny'),
    minuteText: translate('Minuty'),
    secondText: translate('Sekund'),
    currentText: translate('Teď'),
    closeText: translate('OK'),
    ampm: false,
    timeFormat: 'HH:mm:ss'//, //kdyz se zada hh:mm:ss tak to skoci na rok 1899 kdyz tam byl pred tim 21.12.2010
});*/

(function () {
    const e = window.onerror;
    window.onerror = function (err) {
        if (err === 'ResizeObserver loop completed with undelivered notifications.' || err === 'ResizeObserver loop limit exceeded') {
            console.warn('Ignored: ResizeObserver loop limit exceeded');
            return false;
        } else {
            if (typeof e === "function") {
                return e(...arguments);
            }
            return false;
        }
    };
})()

globals.$document.ready(function () {
    mobileNew();
    imageLazyLoad();
    Frontend.Init();
    runAfterAjax();
    import("./b-form-new");
    import("./search-new");
    import("./eshop");
    const inforow = $('.c-info-row-wrap');
    if (inforow.length) {
        const infoHidden = sessionStorage.getItem("infoHidden");
        if (!infoHidden) {
            inforow.show(0);
            inforow.find('.close').on('click', function () {
                inforow.slideUp();
                sessionStorage.setItem("infoHidden", "1");
            });
        }
    }
    fastMessages(globals.$body);
    banners();
    globals.$document.ajaxComplete(function () {
        const tooltips = $('[id*="tooltip"]');
        if (tooltips.length) {
            tooltips.remove();
        }

    });
    globals.$window.on('scroll', function () {
        const head_offset = $('header').height();
        const sidebanners = $('.sidebanners');
        if (sidebanners.length) {
            if (globals.$window.scrollTop() > head_offset) {
                sidebanners.addClass('fixed');
            } else {
                sidebanners.removeClass('fixed');
            }
        }
    });

    (function () {
        const cdImageWrap = $('.CountDown .image-wrap');
        if (cdImageWrap.length) {
            cdImageWrap.on('touchend', function (e) {
                cdImageWrap.toggleClass('show');
            });
        }
    })()

    const motos = $('.js-mototabs');
    if (motos.length) {
        import('./mototabs').then(module => {
            const mototabs = new module.mototabs(motos);
            mototabs.init();
        });
    }

    const manufacturerSlider = $('.manufactures-slider');
    if(manufacturerSlider.length){
        import('./swiper').then(module => {
            module.manufacturerSlider(manufacturerSlider);
        });
    }

    const whatSaySlider = $('#what-say-slick');
    if(whatSaySlider.length){
        import('./swiper').then(module => {
            module.whatSaySlider(whatSaySlider);
        });
    }

    if (typeof RUSTY_MODAL != "undefined") {
        import('./rusty').then(module => {
            module.rustyModal(globals.$body);
        });
    }

    $(".js-hamburger").on('click', function () {
        const _this = $(this);
        _this.toggleClass("c-hamburger--active");
        const target = $(_this.attr('data-target'));
        target.slideToggle("slow", function () {
            if (target.is(":visible")) {
                target.css("display", "flex !important");
            } else {
                if (_this.attr('data-target') === '#moto-navbar') {
                    target.css('transform', '');
                }
            }
        });
        // Zavre vsechny otevrene itemy
        target.find(".c-navbar__list--is-open").removeClass("c-navbar__list--is-open");
        target.find(".c-navbar__dropdown--is-open").removeClass("c-navbar__dropdown--is-open");
        // Change aria atribute
        if (_this.hasClass("c-hamburger--active")) {
            _this.attr("aria-expanded", "true");
            if (_this.attr('data-target') === '#moto-navbar') {
                _this.parent().addClass('burgerOpened');
            }
        } else {
            _this.attr("aria-expanded", "false");
            if (_this.attr('data-target') === '#moto-navbar') {
                _this.parent().removeClass('burgerOpened');
            }
        }
    });

    globals.$body.on("click", function (e){
        const wrap = $('[data-target-id="currency-switcher"]');
        if(!$(e.target).is(wrap) && wrap.is(':visible')){
            $('[data-opener-id="currency-switcher"]').first().trigger('click');
        }
    });

    globals.$body.on("click", "[data-opener-class]", function (e) {
        e.preventDefault();
        e.stopPropagation();
        const _this = $(this);
        const target = _this.attr("data-opener-id");
        if (_this.attr("data-opener-class") === "sidebar-subsection") {
            $("[data-target-id='" + target + "']").slideToggle();
            const parent = _this.closest('.c-sidebar__section');
            parent.toggleClass("is-open");
        } else if (_this.attr("data-opener-class") === "modal") {
            const resize = _this.attr("data-modal-size");
            let body = _this.find('[data-modal-body]');
            const title = _this.find('[data-modal-title]').clone().removeClass('u-none');
            const func = body.attr('data-modal-body').trim();
            if (func && body.attr('data-modal-presenter')) {
                $.ajax({
                    type: "POST",
                    url: window[body.attr('data-modal-presenter')] + func,
                    dataType: "json",
                    success: function (data) {
                        body = data;
                        cModal.open(title, body, resize);
                    }
                });
            } else {
                body = body.clone();
                body.removeClass('u-none');
                cModal.open(title, body, resize);
            }
        } else if (_this.attr("data-opener-class") === "filters") {
            const arrow = $("[data-opener-class='filters']").find(".c-navbar__dropdown");
            if (arrow.css("display") !== "none") {
                $("[data-target='filters']").slideToggle();
                $(arrow.toggleClass("c-navbar__dropdown--is-open"));
            }
        } else if (_this.attr("data-opener-class") === "filters-category") {
            const anotherTarget = $("[data-category-id='" + target + "']");
            const wrapper = $("[data-category-wrapper-id='" + target + "']");
            if (anotherTarget.css("display") === "none") {
                if(window.innerWidth <= 991) {
                    $("[data-category-id]").slideUp("fast", "swing", function () {
                        $("[data-category-wrapper-id]").removeClass("c-filters__category-wrapper--is-open");
                        $(".c-filters__category-header").removeClass("c-filters__category-header--is-open");
                        wrapper.toggleClass("c-filters__category-wrapper--is-open");
                        _this.toggleClass("c-filters__category-header--is-open");
                    });
                } else {
                    wrapper.toggleClass("c-filters__category-wrapper--is-open");
                    _this.toggleClass("c-filters__category-header--is-open");
                }
                anotherTarget.slideToggle();
            } else {
                _this.toggleClass("c-filters__category-header--is-open");
                wrapper.toggleClass("c-filters__category-wrapper--is-open");
                anotherTarget.slideToggle("fast", "swing");
            }
        }
    });

    globals.$window.on('resize', function () {
        if (window.innerWidth > 768) {
            $('.js-hamburger:not([data-target="#moto-navbar"])').each(function () {
                const _this = $(this);
                const target = $(_this.attr('data-target'));
                if (_this.hasClass("c-hamburger--active")) {
                    target.find(".c-navbar__list--is-open").removeClass("c-navbar__list--is-open");
                    target.find(".c-navbar__dropdown--is-open").removeClass("c-navbar__dropdown--is-open");
                    _this.toggleClass("c-hamburger--active");
                    _this.attr("aria-expanded", "false");
                    target.removeAttr('style');
                } else {
                    target.removeAttr('style');
                }
            });
        }
    });
    const prDetail = $('.ProductDetail');
    if(prDetail.length){
        import('./product-detail')
    }
    // const thanksPage = $('.thanksPage');
    // if(thanksPage.length){
    //     import('./sklik')
    // }
    const complaint = $('.c-exchange-chooser');
    if(complaint.length){
        import('./complaint.js')
    }
});

function banners() {
    const mainBanner = $('#top-banners');
    if (mainBanner.length) {
        import('./swiper').then(module => {
            module.mainBanner(mainBanner);
        });
    }
    const fullBanners = $('#full-w-banners');
    if (fullBanners.length) {
        import('./swiper').then(module => {
            module.fullBanner(fullBanners);
        });
    }
    const groupBanner = $('#group-banner');
    if (groupBanner.length) {
        import('./swiper').then(module => {
            module.mainBanner(groupBanner);
        });
    }
}

function fastMessages($body) {
    const messages = $('.FastMessages .js_fastMessages_row > .col-12:not(.js_fastmessage_item)');
    fastMessageStart($body, messages)
}
